/**
 * Single source for the overridable POS API base URLs. Reads the build-time
 * VITE_* values once; these are the defaults under the Flagsmith
 * per-group override layer.
 */

// Overridable endpoint env vars.
export const ENDPOINT_KEYS = {
  rootApi: "VITE_ROOT_API",
  api2: "VITE_API2",
  services: "VITE_SERVICES_API",
  gqlApi: "VITE_GQL_API",
  gqlGateway: "VITE_GQL_GW",
  b2cApi: "VITE_B2C_API",
  certification: "VITE_CERTIFICATION_URL",
  cognitoApi: "VITE_COGNITO_API_URL",
} as const;

export type EndpointEnvVar = (typeof ENDPOINT_KEYS)[keyof typeof ENDPOINT_KEYS];

/** Static build-time endpoint values (the fail-closed defaults). */
export const endpoints: Record<EndpointEnvVar, string> = {
  VITE_ROOT_API: import.meta.env.VITE_ROOT_API || "",
  VITE_API2: import.meta.env.VITE_API2 || "",
  VITE_SERVICES_API: import.meta.env.VITE_SERVICES_API || "",
  VITE_GQL_API: import.meta.env.VITE_GQL_API || "",
  VITE_GQL_GW: import.meta.env.VITE_GQL_GW || "",
  VITE_B2C_API: import.meta.env.VITE_B2C_API || "",
  VITE_CERTIFICATION_URL: import.meta.env.VITE_CERTIFICATION_URL || "",
  VITE_COGNITO_API_URL: import.meta.env.VITE_COGNITO_API_URL || "",
};
